export enum PERIOD_TYPE {
  AM = 'AM',
  PM = 'PM',
}
export enum DIAL_TYPE {
  HOUR = 'hour',
  MINUTE = 'minute',
}